package feature.business.viewModel

import common.constants.KeyConstant
import common.constants.UserDefaults
import feature.address.model.Address
import feature.app.AppViewModel
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import feature.business.model.Business
import feature.business.network.BusinessNetwork
import feature.business.network.CreateBusinessRequest
import feature.business.network.RetrieveBusinessRequest
import feature.business.repository.BusinessRepository
import feature.businessType.handler.BusinessTypeHandler
import feature.sync.BusinessAnalytics
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class BusinessViewModel(private val repository: BusinessRepository = BusinessHandler.shared().repository) :
    AppViewModel() {
    val json = Json { encodeDefaults = true }

    val analytics: StateFlow<ArrayList<BusinessAnalytics>>
        get() = repository.analytics

    val selectedBusiness: StateFlow<Business>
        get() = repository.businessLiveData

    val allBusiness: StateFlow<List<Business>>
        get() = repository.allBusiness


    val createBusiness: StateFlow<Business>
        get() = repository.createBusinessState

    fun loadBusiness() {
        val user = AuthHandler.shared().repository.authLiveData.value
        if (user.mobile != null) {
            val request = RetrieveBusinessRequest(
                userId = user.id,
                mobile = user.mobile!!,
                dialCode = user.DialCode!!
            )
            startLoading()
            BusinessNetwork().retrieve(request) {
                stopLoading()
                if (!it?.payload.isNullOrEmpty()) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        repository.allBusinessLiveData.emit(
                            it!!.payload
                        )
                    }
                }
            }
        }
    }

    fun setUpDefaultBusiness() {
        if (repository.business.value != null && repository.business.value.Id != null) {
            return
        } else {
            CoroutineScope(Job() + Dispatchers.Default).launch {
//                val allBusinessFromDatabase =
//                    DatabaseHandler.shared().database.businessDao().getAllItemsFromDB()
//                if (allBusinessFromDatabase.isNotEmpty()) {
//                    repository.businessLiveData.postValue(allBusinessFromDatabase.first())
//                }
            }
        }
    }

    fun setSelectedBusiness(business: Business) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            repository.businessLiveData.emit(business)
        }
        val businessString = json.encodeToString(business)
        UserDefaults.store(KeyConstant.selectedBusiness, businessString)
    }

    fun createNewBusiness(completion: (Business?) -> Unit) {
        val user = AuthHandler.shared().repository.authLiveData.value
        val unique = Clock.System.now()
        if (!BusinessTypeHandler.shared().repository.businessType?.id.isNullOrEmpty() && user.mobile != null && !createBusiness.value.Name.isNullOrEmpty() && !createBusiness.value.EmailID.isNullOrEmpty() && createBusiness.value.Address != null) {
            startLoading()
            createBusiness.value.Address!!.UserID = user.id
            createBusiness.value.Address!!.UniqueID = unique.toEpochMilliseconds()
            val request = CreateBusinessRequest(
                businessTypeID = BusinessTypeHandler.shared().repository.businessType!!.id!!,
                userId = user.id,
                mobile = user.mobile!!,
                dialCode = createBusiness.value.DialCode!!,
                email = createBusiness.value.EmailID!!,
                address = createBusiness.value.Address!!,
                name = createBusiness.value.Name!!
            )
            BusinessNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload.Id.isNotEmpty()) {
                    val allBusiness = repository.allBusiness.value.toMutableList()
                    allBusiness.add(it.payload)
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        repository.allBusinessLiveData.emit(allBusiness)
                        completion(it.payload)
                    }
                }
            }
        }
    }

    fun updateAddress(
        address: Address, onSuccess: (String) -> Unit, onError: (String) -> Unit
    ) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val unixTime = System.currentTimeMillis()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.address, Gson().toJsonTree(address))
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.uniqueId, unixTime)
//        if (selectedBusiness.value != null) {
//            request.put(
//                KeyConstant.businessID,
//                selectedBusiness.value.Id
//            )
//        }
//        Network.shared().updateAddress(request, { payload ->
//            val businessToUpdate = selectedBusiness.value
//            businessToUpdate.Address = Gson().fromJson(payload.toString(), Address::class.java)
//            businessToUpdate.let { insertDatabase(it) }
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                payload?.let { onSuccess("Updated") }
//            }
//        }, {
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                onError("Updated")
//            }
//        }
//        )
    }

    fun updateInfo(
        business: Business, onSuccess: (String) -> Unit, onError: (String) -> Unit
    ) {
//        val request = JSONObject(Gson().toJson(business))
//        Network.shared().update(request, { payload ->
//            payload?.let {
//                insertDatabase(
//                    Gson().fromJson(
//                        payload.toString(),
//                        Business::class.java
//                    )
//                )
//            }
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                payload?.let { onSuccess("Updated") }
//            }
//        }, { msg ->
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                msg?.let { onError(it) }
//            }
//        }
//        )
    }


    fun insertDatabase(business: Business) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
//            DatabaseHandler.shared().database.businessDao().insert(business)
        }
    }

    fun removeBusinessFromDatabase(id: String) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
//            DatabaseHandler.shared().database.businessDao().delete(id)
        }
    }

    fun clearAll() {
        CoroutineScope(Job() + Dispatchers.Default).launch {
//            DatabaseHandler.shared().database.businessDao().clearAll()
        }
    }

    fun deleteBusiness(
        business: Business
    ) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant._id, business.Id)
//        if (BusinessTypeHandler.shared().repository.businessType != null) {
//            request.put(
//                KeyConstant.businessTypeID,
//                BusinessTypeHandler.shared().repository.businessType!!.Id
//            )
//        }
//        SocketService.shared().send(SocketEvent.DELETE_BUSINESS, request)
    }
}